import React from 'react';
const noop = () => {};
export default ({
  children,
  className,
  isListening = false,
  onClickAway = noop,
}) => {
  const wrapperRef = React.useRef(null);
  const handleClick = React.useCallback(
    event => {
      if (
        wrapperRef &&
        !wrapperRef.current.contains(event.target) &&
        isListening
      ) {
        onClickAway(event);
      }
    },
    [onClickAway, wrapperRef, isListening]
  );
  React.useEffect(() => {
    document.removeEventListener('mousedown', handleClick);
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [handleClick]);

  return (
    <div ref={wrapperRef} className={className}>
      {children}
    </div>
  );
};
